import { Paragraph } from './FormInputText.styles';
import { FormGroup, Label } from './styles/common';

const DEFAULT_PHONE_HELPER_TEXT = 'Inserire un numero di telefono reale.';

const resolveHelperText = (helperText, registration, name) => {
  if (helperText !== undefined) return helperText;
  const fieldName = registration?.name ?? name;
  if (fieldName === 'phone') return DEFAULT_PHONE_HELPER_TEXT;
  return null;
};

export function FormInputText({
  label,
  paragraph,
  type,
  placeholder,
  min,
  max,
  registration,
  valid,
  error,
  value,
  onChange,
  inputId,
  onWheel,
  trim = true,
  classNameInput,
  disabled = false,
  helperText,
  name,
  // Optional note under the field. Marks a value filled in from an uploaded document,
  // so the user knows to check it rather than assume we got it right.
  // Optional note under the field. Used to mark a value that was filled in from an uploaded
  // document, so the user knows to check it rather than assume we got it right.
  hint,
}) {
  const resolvedHelperText = resolveHelperText(helperText, registration, name);

  if (registration === undefined) {
    const handleChange = (e) => {
      onChange(trim ? e.target.value.trim() : e.target.value);
    };

    return (
      <FormGroup>
        {label !== undefined && <Label>{label}</Label>}
        {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
        <input
          placeholder={placeholder}
          id={inputId}
          className={`form-control text-center ${classNameInput} ${error ? 'is-invalid' : ''
          } ${valid ? 'is-valid' : ''}`}
          type={type}
          name={name}
          min={min}
          max={max}
          onWheel={onWheel}
          value={value}
          onChange={handleChange}
          disabled={disabled}
        />
        <div className="invalid-feedback">{error}</div>
        {hint && <p className="form-input-hint">{hint}</p>}
        {resolvedHelperText && (
          <small className="form-text text-black d-block mt-1 fw-bold">
            {resolvedHelperText}
          </small>
        )}
      </FormGroup>
    );
  }

  return (
    <FormGroup>
      {label !== undefined && <Label>{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
      <input
        id={inputId}
        placeholder={placeholder}
        className={`form-control text-center ${classNameInput} ${error ? 'is-invalid' : ''
        } ${valid ? 'is-valid' : ''}`}
        type={type}
        onWheel={onWheel}
        min={min}
        max={max}
        {...registration}
        disabled={disabled}
      />
      <div className="invalid-feedback">{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
      {resolvedHelperText && (
        <small className="form-text text-black d-block mt-1 fw-bold">
          {resolvedHelperText}
        </small>
      )}
    </FormGroup>
  );
}
